<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             :title="data_title"
             icon="la la-link">
    <template #body-content>
      <b-form-group>
        <label for="feed-url">Enter a valid {{ getFeedLabel(true) }} URL:</label>
        <input v-model="feed_url"
               class="form-control"
               name="feed-url"
               type="text">
      </b-form-group>
    </template>
    <template #body-controls>
      <b-button variant="ss-standout" :disabled="!feed_url || waiting_callback" @click="() => close(true)">
        <loader v-if="waiting_callback" small class="mr-2" /> Confirm
      </b-button>
      <b-button variant="ss" :disabled="waiting_callback" @click="() => close(false)">
        <loader v-if="waiting_callback" small class="mr-2" /> Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `feed-url-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: `feed-url-modal`,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    feed_url: null,
    data_title: null,
  }),
  mounted() {
    this.data_title = this.title ?? `Enter a ${this.getFeedLabel(true)} URL`;
  },
  methods: {
    close(confirmed) {
      this.close_data.confirm = confirmed;
      this.close_data.url = this.feed_url;
      this.complete();
    },
  },
};
</script>
